function isAppOnly() {
  if (typeof window === 'undefined') return false;

  const searchParams = new URLSearchParams(window.location.search);

  return searchParams.get('APPONLY') === '1';
}

const IS_APP = isAppOnly();

export {
  IS_APP,
};
